const FILES: Record<number, string> = {
  1: "m24_oxfirev3.png",
  2: "M33CancerBubbleSP.gif",
  3: "m06_diaiceburnv3.png",
  4: "xxx_queen_ophiucav3.PNG",
  5: "xxx_crown_thunderv3.PNG",
  6: "xxx_plesio_surfv3.PNG",
  7: "M36GoatKungfuSP.gif",
  8: "m27_cygnuswingv3.png",
  9: "M24HarpNoteSP.gif",
  10: "m09_clubstrongv3.png",
  11: "m42_apolloflamev3.png",
  12: "m33_phantomblackv3.png",
  13: "xxx_leo_kingdomGX.PNG",
  14: "M18EmptySP.gif",
  15: "m30_wolfforestv3.png",
  16: "xxx_gemini_sparkv3.PNG",
  17: "xxx_libra_scalesv3.PNG",
  18: "m15_jackcorvusv3.png",
  19: "M15CondorGeographSP.gif",
  20: "m39_moondisasterv3.png",
  21: "m03_spademagnetsV3.png",
  22: "xxx_general_aurigav3.PNG",
  23: "m12_queenvirgov3.png",
  24: "xxx_pegasus_magicGX.PNG",
  25: "m21_acidacev3.png",
  26: "Andromeda.png",
  27: "m36_buraiv3.png",
  28: "gchip03g.png",
  29: "xxx_dragon_skyGX.PNG",
  30: "m18_gravejokerv3.png",
  31: "SP_G02RaMu.gif",
  32: "gchip01f.png",
};

export function v3ImagePathFor(id: number): string | null {
  const file = FILES[id];
  return file ? `${import.meta.env.BASE_URL}images/v3/${file}` : null;
}
